import { types } from "mobx-state-tree";
import fetcher from "../utils/fetcher";
import { persist } from "../utils/persist";
import { cleanFormError } from "../utils/errorMessage";

const RepairPagesStore = types
  .model("RepairPagesStore", {
    repairPages: types.frozen(),
    selectedRepairPage: types.frozen(),
    selectedProject: types.frozen(),
    error: types.frozen(),
    sites: types.frozen(),
    selectedTheme: types.frozen(),
    licenses: types.frozen(),
    locations: types.frozen(),
    domains: types.frozen(),
    siteAreas: types.frozen(),
    statuses: types.frozen(),
    defectList: types.frozen(),
    allRepairMessages: types.frozen(),
  })
  .actions((self) => {
    const getRepairPages = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.repairPages.get_repair_pages();
      if (response?.status === 200 && response?.data) {
        const repairPages = response.data;
        self.setRepairPages(repairPages);

        return repairPages;
      } else {
        self.setError("error:error_failed_get_repair_pages_req", response);
      }
    };

    const getRepairPage = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.repairPages.get_repair_page();
      if (response?.status === 200 && response?.data) {
        const repairPage = response.data;

        return repairPage;
      } else {
        self.setError("error:error_failed_get_repair_page_req", response);
      }
    };

    const addRepairPage = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.repairPages.add_repair_page();
      if (response?.status === 200 && response?.data) {
        const repairPage = response.data;

        return repairPage;
      } else {
        self.setError("error:error_failed_add_repair_page_req", response);
      }
    };

    const updateRepairPage = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.repairPages.update_repair_page();
      if (response?.status === 200 && response?.data) {
        const repairPage = response.data;
        return repairPage;
      } else {
        self.setError("error:error_failed_update_repair_page_req", response);
      }
    };

    const getDomains = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.repairPages.get_domains();
      if (response?.status === 200 && response?.data) {
        const domains = response.data;
        self.setDomains(domains);
        return domains;
      } else {
        self.setError("error:error_failed_get_domains_req", response);
      }
    };

    const getLocations = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.repairPages.get_locations();
      if (response?.status === 200 && response?.data) {
        const locations = response.data;
        self.setLocations(locations);
        return locations;
      } else {
        self.setError("error:error_failed_get_locations_req", response);
      }
    };

    const getSiteAreas = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.repairPages.get_site_areas();
      if (response?.status === 200 && response?.data) {
        const areas = response.data;
        self.setSiteAreas(areas);
        return areas;
      } else {
        self.setError("error:error_failed_get_areas_req", response);
      }
    };

    const getStatuses = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.repairPages.get_repair_page_statuses();
      if (response?.status === 200 && response?.data) {
        const statuses = response.data;
        self.setStatuses(statuses);

        return statuses;
      } else {
        self.setError("error:error_failed_get_statuses_req", response);
      }
    };

    const getExaminUserData = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.repairPages.get_examin_user_data();

      if (response?.status === 200 && response?.data) {
        const user = response?.data;
        return user;
      } else {
        self.setError("error:error_failed_get_examin_user_data", response);

        return null;
      }
    };

    const addConversationMessage = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.repairPages.add_conversation_message();
      if (response?.status === 200 && response?.data) {
        const messages = await getConversationMessages(data);
        return messages?.[0]?.ZCOB_TENANTCONV_SUBFORM || [];
      } else {
        self.setError("error:error_failed_add_conversation_message_req", response);
      }
    }

    const updateConversationMessage = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.repairPages.update_conversation_message();
      if (response?.status === 200 && response?.data) {
        const messages = await getConversationMessages(data);
        return messages?.[0]?.ZCOB_TENANTCONV_SUBFORM || [];
      } else {
        self.setError("error:error_failed_update_conversation_message_req", response);
      }
    }

    const updateMessagesAsRead = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.repairPages.update_messages_as_read();
      if (response?.status === 200 && response?.data) {
        const messages = await getConversationMessages(data);
        return messages;
      } else {
        self.setError("error:error_failed_update_messages_as_read_req", response);
      }
    }



    const getConversationMessages = async (data) => {
      self.setError("");
      const response = await fetcher()
        .post(data)
        .from.repairPages.get_conversation_messages();
      if (response?.status === 200 && response?.data) {
        const repairs = response.data?.value || [];
        const messages = repairs.map(rep => (rep.ZCOB_TENANTCONV_SUBFORM?.map(msg => ({
          ...msg, REPAIRNAME: rep.REPAIRNAME
        })) || [])).flat() || [];
        self.setAllRepairMessages(messages);
        return repairs;
      } else {
        self.setError("error:error_failed_get_conversation_messages_req", response);
      }
    }




    const setStatuses = async (statuses) => {
      self.statuses = statuses;
    };

    const setDefectList = async (defects) => {
      self.defectList = defects;
    };

    const setLocations = async (locations) => {
      self.locations = locations;
    };

    const setSiteAreas = async (siteAreas) => {
      self.siteAreas = siteAreas;
    };
    const setDomains = async (domains) => {
      self.domains = domains;
    };

    const setRepairPages = (repairPages) => {
      self.repairPages = repairPages;
    };

    const setSelectedRepairPage = (repairPage) => {
      self.selectedRepairPage = repairPage;
    };

    const setAllRepairMessages = (messages) => {
      self.allRepairMessages = messages;
    };


    function setError(error, response) {
      self.error = cleanFormError(response, error);
    }

    return {
      setSelectedRepairPage,
      getRepairPages,
      setRepairPages,
      getRepairPage,
      addRepairPage,
      getSiteAreas,
      getDomains,
      getLocations,
      setLocations,
      setDomains,
      setSiteAreas,
      updateRepairPage,
      setError,
      getStatuses,
      setStatuses,
      getExaminUserData,
      setDefectList,
      addConversationMessage,
      getConversationMessages,
      updateConversationMessage,
      setAllRepairMessages,
      updateMessagesAsRead
    };
  })
  .views((self) => ({
    get isError() {
      return !!self.error;
    },
  }));

let sessionStorageTenant = JSON.parse(
  window.sessionStorage.getItem("coralis-tenants-storerepairpage")
);

const repairPagesStore = RepairPagesStore.create({
  repairPages: sessionStorageTenant?.repairPages || [],
  selectedRepairPage: sessionStorageTenant?.selectedRepairPage || {},
  error: "",
  selectedTheme: sessionStorageTenant?.selectedTheme || {},
  sites: sessionStorageTenant?.selectedTheme || [],
  licenses: 0,
  domains: sessionStorageTenant?.domains || [],
  locations: sessionStorageTenant?.locations || [],
  siteAreas: sessionStorageTenant?.siteAreas || [],
  statuses: sessionStorageTenant?.statuses || [],
  defectList: [],
  allRepairMessages: sessionStorageTenant?.allRepairMessages || [],
});

sessionStorageTenant = persist(
  "coralis-tenants-storerepairpage",
  repairPagesStore,
  {
    storage: window.sessionStorage,
    jsonify: true,
  }
);

export default repairPagesStore;
